import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ModalRoot from 'components/Modal/ModalRoot';
import Uploader from '../containers/Uploader';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ImageLibraryTable from '../containers/ImageLibraryTable';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    flexDirection: 'column',
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  paper: {
    padding: 10,
  },
  paperTopPadding: {
    marginTop: 10,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    paddingBottom: theme.spacing(),
  },
  select: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
  },
  formControl: {
    minWidth: '20%',
    margin: '15px 20px',
  },
});

export class ImageLibrary extends Component {
  constructor(props) {
    super(props);

    this.renderDropImages = this.renderDropImages.bind(this);
  }

  state = {
    api: null,
    team: null,
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  renderSelect(title, ref, state, list) {
    const { classes } = this.props;

    return (
      <FormControl className={classes.formControl}>
        <InputLabel ref={ref} id="demo-simple-select-outlined-label">
          {title}
        </InputLabel>
        <Select
          id="demo-simple-select-outlined"
          value={state ? state : ''}
          onChange={event => {
            this.handleChange(ref, event.target.value);
            if (ref === 'api') {
              this.handleChange('team', null);
              this.props.updateSelect(event.target.value);
            }
          }}
        >
          <MenuItem value={null}>
            <em>None</em>
          </MenuItem>

          {list.map(row => (
            <MenuItem key={row._id} value={row._id}>
              <div className={classes.select}>{row.name}</div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderDropImages() {
    const { apiList, teamList } = this.props;

    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper elevation={0}>
                {this.renderSelect('League', 'api', this.state.api, apiList)}
                {this.renderSelect('Team', 'team', this.state.team, teamList)}
                <Uploader api={this.state.api} team={this.state.team} />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  renderTable() {
    const { classes, updateN } = this.props;

    return (
      <Grid container spacing={3} style={{ height: '500px' }}>
        <Grid item xs={12}>
          <Typography className={classes.title} variant="h6" gutterBottom>
            Uploaded Images
          </Typography>
          <Paper className={classes.paper} elevation={0}>
            <ImageLibraryTable
              updateNumber={updateN}
              leagueId={this.state.api}
              team={this.state.team}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {'Image Library'}
          </Typography>
        </div>
        {this.renderDropImages()}
        {this.renderTable()}
        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(ImageLibrary);
